import { getTokenAuthorization } from "./authService";
import jwt from "jsonwebtoken";

export const tokenAuthorization = async () => {
  try {
    const token = localStorage.getItem("ValidationToken");
    
    // If no token exists, get a new one
    if (!token) {
      const newToken = await getTokenAuthorization();
      localStorage.setItem("ValidationToken", newToken.Token);
      return newToken.Token;
    }
    
    // Decode and check expiration
    const decoded = jwt.decode(token);
    if (!decoded?.exp) {
      // Token is invalid, get a new one
      const newToken = await getTokenAuthorization();
      localStorage.setItem("ValidationToken", newToken.Token);
      return newToken.Token;
    }
    
    const { exp } = decoded;
    const dataTokenCalculation = exp * 1000;

    if (Date.now() >= dataTokenCalculation) {
      const newToken = await getTokenAuthorization();
      localStorage.setItem("ValidationToken", newToken.Token);
      return newToken.Token;
    }

    return token;
  } catch (e) {
    console.log(`Error: ${e}`);
    return "";
  }
};
